import React                from 'react'
import { useDispatch }      from 'react-redux'
import * as viewElements    from '../../../../actions/creators/view-elements';
import Blogx                from "./blog"
import Delete               from "./delete"
import Edit                 from "./edit"

const Sectors = props => {
    const dispatch                      = useDispatch();
    const onClickHandler = () => {
        dispatch(
            viewElements.createModal({
                title: "Yeni Sektor Ekle 🥳",
                full : true,
                body  : props => <Blogx 
                                    { ...props } 
                                />
            })
        )
    }
    const deleteOnClickHandler = () => {
        dispatch(
            viewElements.createModal({
                title: "Sektor Siliniyor 🥺",
                full : true,
                body  : props => <Delete 
                                    { ...props } 
                                />
            })
        )
    }
    const editOnClickHandler = () => {
        dispatch(
            viewElements.createModal({
                title: "Sektor Düzenle ✍️",
                full : true,
                body  : props => <Edit 
                                    { ...props } 
                                />
            })
        )
    }

    return (
        <div className="blog-container">
            <div className="header-title">Dashboard / Sektorler</div>
            <div className="blog-container-section">
                <div className="box add-blog" onClick={onClickHandler}>
                    <p>Sektor Ekle</p>
                    <i className="far fa-plus-square"></i>
                </div>
                <div className="box">
                    <p>Toplam Sektor Sayısı</p>
                    <span>21</span>
                </div>
                <div className="box">
                    <p>Toplam Görüntülenme</p>
                    <span>21</span>
                </div>
            </div>
            <div className="table-container">  
            <table>
                <thead>
                <tr>
                    <td>Sektor Resimi</td>
                    <td>Sektor Başlığı</td>
                    <td>İşlemler</td>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                    <tr>
                        <td className="blog-img">
                            <img src="https://picsum.photos/200/300" />
                        </td>
                        <td>Deneme</td>
                        <td>
                            <i className="fas fa-edit option" onClick={editOnClickHandler}/>
                            <i className="fas fa-trash-alt option" onClick={deleteOnClickHandler} />
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>
    )
}

export default Sectors